module.exports = __webpack_public_path__ + "img/saint_barthelemy.1aa8ba1.webp";